<template>
  <v-text-field
    outlined
    @blur="handleValid(); $emit('blur', $event);"
    v-bind="$attrs"
    :value="value"
    :rules="emailRules(required)"
    :error="hasDupeEmail"
    :errorMessages="hasDupeEmail ? ['A record already exists with this value'] : $attrs.errorMessages"
    @input="handleValid(); $emit('input', $event);"
    @keyup="checkDupes()"
    ref="email"
  ></v-text-field>
</template>

<script>
import * as validator from 'email-validator';

export default {
  name: 'EsEmailField',
  props: {
    value: String,
    required: {
      type: Boolean,
      default: false,
    },
    hasDupeEmail: {
      type: Boolean,
      default: false,
    }
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  mounted() {
    if (this.value) {
      this.$refs.email.focus();
      this.$nextTick(this.$refs.email.blur());
    }
  },
  methods: {
    handleValid() {
      const errorState = this.$refs.email.hasError;
      this.$emit('isInvalid', errorState);
    },
    checkDupes() {
      this.$emit('checkDupes', { newValue: this.value, isValid: validator.validate(this.value) });
    },
    emailRules(req) {
      return [
        (v) => (!!v || !req) || 'Email is required',
        (v) => (!v || validator.validate(v)) || 'Please enter a valid email address.',
      ];
    },
  },
};
</script>
